import React, { Component } from 'react'
import styled from 'styled-components'
import { Container, Row, Col, media } from 'styled-bootstrap-grid'

const Wrapper = styled.div`
  padding-bottom: 90px;

  ${media.xs`
    padding-bottom: 30px;
  `}
`

const Top = styled.div`
  padding: 50px 0 ${props => (props.hasImage ? 150 : 50)}px;
  background-color: ${props => props.theme.colors.tones.dark};

  ${media.xs`
    padding: 25px 0 75px;
  `}
`

const Text = styled.h1`
  margin: 0 0 10px;

  font-size: 30px;
  line-height: 40px;
  font-weight: 200;
  color: #fff;

  ${media.xs`
    font-size: 22px;
    line-height: 28px;
  `}
`

const PostType = Text.extend`
  color: ${props => props.theme.colors.tones.light};
  font-family: ${props => props.theme.monoFont};
  font-size: 12px;
`

const Introduction = Text.withComponent('div').extend`
  color: ${props => props.theme.colors.tones.light};
  max-width: 800px;
  margin-top: 30px;
`

const Image = styled.div`
  padding-top: 31%;
  background-image: url('${props => props.src}');
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  margin-top: -50px;

  ${media.xs`
    margin-left: -20px;
    margin-right: -20px;
    padding-top: 50%;
  `}
`

class index extends Component {
  render() {
    const {
      introduction,
      image,
      post: { title },
      type
    } = this.props
    const hasLabel = type !== 'page'
    const sourceUrl = image && image.sourceUrl

    return (
      <Wrapper>
        <Top hasImage={!!sourceUrl}>
          <Container fluid>
            <Row>
              <Col hidden={!hasLabel} md={3} lg={2} lgOffset={1}>
                <PostType>
                  {type === 'case' ? 'Case' : ''}
                  {type === 'page' ? 'Page' : ''}
                </PostType>
              </Col>
              <Col md={hasLabel ? 9 : 12} lg={8} lgOffset={hasLabel ? 0 : 2}>
                <Text>{title}</Text>
                <Introduction
                  dangerouslySetInnerHTML={{ __html: introduction }}
                />
              </Col>
            </Row>
          </Container>
        </Top>
        {sourceUrl && (
          <Container fluid>
            <Row>
              <Col lg={10} lgOffset={1}>
                <Image src={sourceUrl} />
              </Col>
            </Row>
          </Container>
        )}
      </Wrapper>
    )
  }
}

export default index



// WEBPACK FOOTER //
// ./src/ui/components/modules/Header/index.js